import { detectLayoutModule, LayoutModuleKey } from './tab-limit-util';

export const VALID_ROUTES = [
  'bank-account/list',
  'embargo/list',
  'income-voucher/list',
  'payment-order-reception/list',
  'expense-voucher/list',
  'bank-payment/list',
  'payment-annulment/list',
  'payment-confirmation/list',
  'electronic-payment-config/list',
  'electronic-payment-gen/list',
  'bank-transfer/list',
  'bank-transfer-annulment/list',
  'bank-closure/list',
  'masters/cost-center/list',
  'masters/cost-center-type/list',
  'masters/masters',
  'paises/list',
  'departamentos/list',
  'ciudades/list',
  'accrual/list',
  'accrual-approval/list',
  'accrual-annulment/list',
  'journal-entry/list',
  'journal-entry-annulment/list',
  'depreciation/list',
  'deferred-process/list',
  'accounting-closure/list',
  'bank-reconciliation-config/list',
  'bank-reconciliation/list',
  'billing-parameters/list',
  'billing-concept/list',
  'invoice-elaboration/list',
  'credit-debit-note/list',

  'budget-parameters/list',
  'resource-type/list',
  'funding-source/list',

  'consecutivo-tipo/list',
  'consecutivo-def/list',
  'parametros-definicion/list',
  'parametros-plantilla/list',
  'parametros-rol/list',
  'parametros-compania/list',
  'roles/list',
  'usuarios/list',

  'dashboard',
  'vault',
  'ingest',
  'preservation',
  'retention',
  'legal-hold',
  'reports',
  'cloud',
  'notifications',
  'audit',
  'settings',
  'admin/dashboard',
  'admin/tenants',
  'admin/permissions',
  'admin/servers',
  'admin/users',
  'admin/module-permissions',
  'repository-admin',
  'preservation-messages',
  'accounting-parameters/list',
  'tipo-plan/list',
  'tipo-plan-historico/list',
  'plan-cuentas-historico/list',
  'estructura-historico/list',
  'dependency/list',
  'dian-concept/list',
  'account-structure/list',
  'currency',
  'account-plan/list',
  'third-party/list',
  'accounting-format/list',
  'accrual/list',
  'deferred-process/list',
  'journal-entry/list',
  'accrual-approval/list',
  'accrual-annulment/list',
  'treasury-parameters/list',
  'depreciation/list',
  'other-discount/list',
  'other-deductions/list',
  'deferred/list',
  'journal-entry-deferred/list',
  'journal-classification/list',
  'accounting-concepts/list',
  'journal-entry-type/list',
  'accounting-currency/list',
  'exchange-rate/list',
  'treasury-third-party/list',
  'payment-annulment/list',
  'bank-payment/list',
  'expense-voucher/list',
  'income-voucher/list',
  'income-annulment/list',
  'files-scructure-configurations/list',
  'bank-transfer/list',
  'bank-transfer-annulment/list',
  'bank-closure/list',
] as const;

export type ValidRoute = (typeof VALID_ROUTES)[number];

export function isRouteValid(route: string): boolean {
  if (!route) return false;

  let decoded = route;
  try {
    decoded = decodeURIComponent(route);
  } catch {
    decoded = route;
  }

  const cleanRoute = decoded
    .replace(
      /^\/layout\/(accounting|tesorería|tesoreria|budget|vault|maestros|products|company)\//i,
      '',
    )
    .split('?')[0]
    .split('#')[0]
    .toLowerCase()
    .trim();

  const isValid = VALID_ROUTES.some(
    (valid) => cleanRoute === valid.toLowerCase() || cleanRoute.endsWith('/' + valid.toLowerCase()),
  );

  return isValid;
}

export function getModuleFromRoute(route: string): LayoutModuleKey | null {
  if (!route) return null;
  return detectLayoutModule(route);
}
